import { h } from 'preact';
import { useEffect, useState } from 'preact/hooks';

import { PlaySmallIcon } from '@uw/icons';
import { useConnect } from 'helpers/use-connect-to-global-store';
import { stateStore } from 'global/state.store';
import { headerStore } from 'global/header.store';
import { widgetScreensRoutingStore } from 'global/widget-screens-routing.store';
import { remediationStore, Violations as ViolationsType } from 'global/remediation.store';
import { useViolationsReport } from 'components/violations/use-violations-report';

import './about.scss';

// This page should be in English for all languages
export const About = () => {
  const { downloadPdfReport } = useViolationsReport();
  const [violations] = useConnect<ViolationsType>(remediationStore.violations$, null);
  const [isPlaying, setIsPlaying] = useState(false);
  const onPlay = () => {
    setIsPlaying(true);
  };

  const goToUpdate = () => {
    widgetScreensRoutingStore.setPerSiteSettingsFlowThisSite$.next();
    widgetScreensRoutingStore.updateState$.next({
      path: 'siteRemediationUpgradeView',
      value: 'main.logged.dashboard',
    });
    stateStore.state.next('main.logged.site_remediation_upgrade');
  };

  useEffect(() => {
    headerStore.setBackStateToHomePage();
    headerStore.title.next(`About UserWay's AI Widget`);
  }, []);

  return (
    <div className="uwaw-about">
      <h2 className="uwaw-about__title">
        Learn how <strong>UserWay</strong> Protects your site from accessibility related lawsuits
        and ensures <strong>ADA</strong> compliance!
      </h2>
      {isPlaying ? (
        <div className="uwaw-video">
          <iframe
            className="uwaw-video__poster"
            width="100%"
            height="305"
            src="https://www.youtube.com/embed/5n6_PtaYo0s?autoplay=1&mute=1"
            title="YouTube video player - UserWay Demo"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          />
        </div>
      ) : (
        <div className="uwaw-video">
          <button
            className="uwaw-video__poster"
            type="button"
            onClick={onPlay}
            aria-label="Play UserWay Demo video"
          >
            <img
              src="./frontend/images/widget-v4.jpg"
              srcSet={`./frontend/images/widget-v4.jpg 1x, ./frontend/images/widget-v4@2x.jpg 2x`}
              alt="UserWay Demo video preview"
            />
            <span className="uwaw-video__btn">
              <PlaySmallIcon aria-hidden="true" />
            </span>
          </button>
        </div>
      )}

      <div className="uwaw-about__cta">
        <button
          onClick={goToUpdate}
          type="button"
          aria-label="Upgrade Widget"
          className="uwaw-btn uwaw-btn_blue"
        >
          Upgrade Now
        </button>
        <a
          href="https://userway.org/demo/"
          target="_blank"
          className="uwaw-btn uwaw-btn_border"
          rel="noopener"
        >
          Schedule a Demo with our Expert
        </a>
      </div>

      <p className="uwaw-about__description">
        <a aria-label="Download ADA accessibility report" role="button" onClick={downloadPdfReport}>
          Download
        </a>
        &nbsp;
        <strong>ADA</strong> report showing&nbsp;
        {!!violations.totalCount && (
          <span className="uwaw-about__violations">{violations.totalCount}</span>
        )}
        accessibility violations
      </p>
    </div>
  );
};
